export default [
  'ESTOQUE',
  'OFICINA CREDENCIADA',
  'VEÍCULO DO CLIENTE',
  'EM POSSE DO CLIENTE',
  'ASSISTÊNCIA',
  'TRANSPORTE',
  'EXTRAVIADO',
  'SEM CONSERTO',
  'CANCELADO',
  'RASTREADOR DESCONTINUADO'
]
